// extracted by mini-css-extract-plugin
export default {"warning":"src-constrains-DraggableModules-ContentGroup-css__warning--H1i3D"};